<template>
  <div class="BusinessInformation">
    <div class="top">
      <div>经营信息</div>
      <el-select
        v-model="year"
        placeholder="年份"
        @change="getSearch"
        clearable
      >
        <el-option
          v-for="item in yearList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-form :model="ruleForm" ref="ruleForm">
      <div class="form-item">
        <div class="label">年产值（万元）</div>
        <el-form-item prop="entTel">
          <el-input
            v-model="ruleForm.outputValue"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">年营业收入（万元）</div>
        <el-form-item prop="createBy">
          <el-input
            v-model="ruleForm.businessIncome"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">出口总额（万元）</div>
        <el-form-item prop="entWeb">
          <el-input
            v-model="ruleForm.totalExport"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>

      <div class="form-item">
        <div class="label">实缴税收（万元）</div>
        <el-form-item prop="smsTypes">
          <el-input
            v-model="ruleForm.taxRevenue"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">利润总额（万元）</div>
        <el-form-item prop="jbrTel">
          <el-input
            v-model="ruleForm.totalProfit"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">工资总额（万元）</div>
        <el-form-item prop="smsTypes">
          <el-input
            v-model="ruleForm.grossSalary"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">研发经费总额（万元）</div>
        <el-form-item prop="financialTel">
          <el-input
            v-model="ruleForm.totalResearch"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">固定资产（万元）</div>
        <el-form-item prop="smsTypes">
          <el-input
            v-model="ruleForm.fixAssets"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">资产总额（万元）</div>
        <el-form-item prop="telephone">
          <el-input
            v-model="ruleForm.totalAssets"
            placeholder="请输入"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div>
      <el-button type="primary" v-if="isDisabled" @click="isDisabled = false"
        >编 辑</el-button
      >
      <el-button type="primary" v-if="!isDisabled" @click="save()"
        >保 存</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  getManagementData,
  updateManagementData
} from '@api/corporateInteraction/enterprise'
export default {
  name: 'BusinessInformation',
  data() {
    return {
      year: '',
      yearList: [],
      ruleForm: {},
      isDisabled: true
    }
  },
  mounted() {
    this.year = new Date().getFullYear()
    for (let i = this.year - 4; i <= this.year; i++) {
      this.yearList.push({
        label: i,
        value: i
      })
    }
    this.getSearch()
  },
  methods: {
    getSearch() {
      const creditCode =
        this.$route.query.creditCode || this.$store.state.user.userInfo.nickName // 政府端，从路由中获取，企业端，从存储中获取
      const params = {
        creditCode: creditCode,
        dataYear: this.year
      }
      getManagementData(params).then((res) => {
        if (res.data.code === '0000') {
          this.ruleForm = res.data.data
        }
      })
    },
    save() {
      let data = { ...this.ruleForm }
      data.dataYear = this.year
      data.creditCode =
        this.$route.query.creditCode || this.$store.state.user.userInfo.nickName
      updateManagementData(data).then((res) => {
        if (res.data.code == '0000') {
          this.isDisabled = true
          this.$message.success('修改成功')
          this.getSearch()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.BusinessInformation {
  .top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .business-content {
    margin-top: 20px;
    height: auto;
  }
  .form-item {
    display: inline-block;
    font-size: 14px;
    color: #000;
    /deep/.el-input {
      width: 80%;
    }
    /deep/.el-input.is-disabled .el-input__inner {
      background-color: #fff;
      border-color: #dfe4ed;
      color: #000;
    }
    width: 50%;
    .label {
      margin-bottom: 8px;
    }
  }
}
</style>
